// ============================================================
//  environment.prod.ts  →  PRODUCCIÓN
// ============================================================

export const environment = {
  production: true,
  apiUrl: 'https://api.myplacetoday.com/api',
  storageUrl: 'https://api.myplacetoday.com/storage',
  mercadoPagoPublicKey: 'APP_USR-43d8bcf4-ef1a-4b23-866e-1b49cf359856',
  googleClientId:
    '152743933513-pfdjuomgqaao6jco19jqfra2ddji3ch5.apps.googleusercontent.com',
  sentryDsn:
    'https://385f842c359e34360071449d8fd8be28@o4511393791016960.ingest.us.sentry.io/4511393792458752',
};
